export const environment = {
  production: true,
  baseUrl: 'https://test.api.jfl.tracksure.ai/',
};
